import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appPreventDefault]'
})
export class PreventDefaultDirective {

  constructor() { }


  @HostListener('click', ['$event'])
  preventClick(e: MouseEvent): any {
    e.preventDefault();
    e.stopPropagation();
  }

  @HostListener('keydown', ['$event'])
  preventEnter(e: KeyboardEvent): any {
    if (e.code === 'Enter' || e.code === 'Return' || e.code === 'NumpadEnter') {
      e.preventDefault();
      e.stopPropagation();
    }
  }
}
